import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../Store';

const initialState: LoadingModalProps = {
  isVisible: false,
  title: 'Please Wait',
  description: 'Loading is in progress',
};

const loadingModalSlice = createSlice({
  name: 'loadingModal',
  initialState,
  reducers: {
    loadingShow: (state, action: PayloadAction<LoadingModalProps | undefined>) => {
      if (!action || !action.payload) {
        return { ...initialState, isVisible: true };
      }
      return {
        ...state,
        isVisible: true,
        title: action.payload.title,
        description: action.payload.description,
      };
    },
    loadingHide: state => ({ ...state, isVisible: false }),
  },
});

export const { loadingShow, loadingHide } = loadingModalSlice.actions;

export const isVisibleSelector = (state: RootState) => state.loadingModal.isVisible;
export const titleSelector = (state: RootState) => state.loadingModal.title;
export const descriptionSelector = (state: RootState) => state.loadingModal.description;

export default loadingModalSlice.reducer;
